__turbopack_context__.v({
  "expanded": "ToggleButton-module-scss-module__iIpIPG__expanded",
  "playlistPlaybarCaret": "ToggleButton-module-scss-module__iIpIPG__playlistPlaybarCaret",
  "playlistTooltip": "ToggleButton-module-scss-module__iIpIPG__playlistTooltip",
  "playlistTooltipChevron": "ToggleButton-module-scss-module__iIpIPG__playlistTooltipChevron",
  "tiny": "ToggleButton-module-scss-module__iIpIPG__tiny",
  "toggleIconContainer": "ToggleButton-module-scss-module__iIpIPG__toggleIconContainer",
});
